import create, { StoreApi } from 'zustand';

import { assertNever } from 'utils/assertNever';

import { getInitialData, newTimeline } from './data';
import { Store } from './types';

export const useInnskraningStore = create<Store>((set, get, api: StoreApi<Store>) => ({
  ...getInitialData(false),

  setUser: (user) => set((state) => ({ ...state, user })),

  setIsKassar: (isKassar) => set((state) => ({ ...state, isKassar })),

  setSelectedProperties: (selectedProperties) => {
    set((state) => ({
      ...state,
      selectedProperties,
    }));
  },
  setPropertyDelivered: (propertyDelivered) =>
    set((state) => ({ ...state, propertyDelivered })),

  setAddresses: (addresses) => {
    set((state) => ({
      ...state,
      addresses,
    }));
  },

  setOfferType: (offerType) => {
    set((state) => ({
      ...state,
      offerType,
    }));
  },

  setError: (error) => set((state) => ({ ...state, error })),
  clearError: () =>
    set((state) => ({
      ...state,
      error: {
        title: '',
        message: '',
      },
    })),

  setMailinglist: (mailinglist) => set(() => ({ mailinglist })),

  setScene: (sceneKey, isKassar) => {
    const scene = newTimeline[sceneKey];

    switch (sceneKey) {
      case 'initialScene':
        // RESET STORE
        api.setState(getInitialData(isKassar));

        set(() => ({
          videoConfig: scene,
        }));
        break;

      case 'transitionToRoomba':
        set(() => ({
          isLoggedIn: true,
          videoConfig: scene,
        }));
        break;

      case 'transitionToAddressPicker':
      case 'addressPickerResults':
      case 'roombaStartLoop':
      case 'roombaExitLoop':
      case 'addressConfirm':
      case 'transitionToNight':
        set(() => ({
          videoConfig: scene,
        }));
        break;

      case 'signatureComplete':
        set(() => ({
          ...getInitialData(isKassar),
          isCompleted: true,
          videoConfig: scene,
        }));
        setTimeout(() => {
          get().setScene('loopDisco', isKassar);
        }, scene.endTime - scene.startTime);
        break;

      case 'loopDisco':
        set(() => ({
          videoConfig: scene,
        }));
        break;

      default:
        assertNever(sceneKey);
        break;
    }
  },
}));
